import React, { useState } from 'react';

const VideoAccordion = () => {
  const [activeModule, setActiveModule] = useState(null);
  const [activeVideo, setActiveVideo] = useState(null);

  const modules = [
    {
      title: 'Aula 1 - O que é gravura?',
      videos: [
        { 
          title: 'O que é gravura?', 
          url: 'https://www.youtube.com/embed/Q5fnpydvPAU'  // Example YouTube embed URL
        },
        { title: 'Origens da gravura no Oriente', url: 'https://example.com/gravura-oriente' },
        { title: 'Gravura na Europa: da Idade Média ao Renascimento', url: 'https://example.com/gravura-europa' }
      ]
    },
    {
      title: 'Aula 2 - História da gravura',
      videos: [
        { title: 'Xilogravura: a matriz de madeira', url: 'https://example.com/xilogravura' },
        { title: 'Gravura em metal: da calcografia à água-forte', url: 'https://example.com/gravura-metal' },
        { title: 'Litografia e serigrafia: a pedra e a tela', url: 'https://example.com/litografia' },
        { title: 'Outras técnicas e experimentações', url: 'https://example.com/outras-tecnicas' }
      ]
    },
    {
      title: 'Aula 3 - Xilogravura',
      videos: [
        { title: 'Gravura no Brasil: das origens ao modernismo', url: 'https://example.com/gravura-brasil' },
        { title: 'Oswaldo Goeldi: mestre da xilogravura', url: 'https://example.com/goeldi' },
        { title: 'Gravura popular: J. Borges e a literatura de cordel', url: 'https://example.com/cordel' }
      ]
    },
    {
      title: 'Aula 4 - Calcogravura',
      videos: [
        { title: 'Tiragens e Provas na Gravura', url: 'https://example.com/tiragens' },
        { title: 'O Mercado da Gravura', url: 'https://example.com/mercado' }
      ]
    },
    {
      title: 'Aula 5 - Litografia',
      videos: [
        { title: 'Gravura contemporânea e novas tecnologias', url: 'https://example.com/contemporanea' }
      ]
    }
  ];

  // Função de toggle bloqueada - não faz nada quando clicada
  const toggleModule = (index) => {
    // Esta função está desativada para bloquear a abertura do conteúdo
    return;
  };

  // Função de toggle do vídeo bloqueada - não faz nada quando clicada
  const toggleVideo = (moduleIndex, videoIndex) => {
    // Esta função está desativada para bloquear a abertura do vídeo
    return;
  };

  // Estilo modificado para mostrar que não é clicável
  const accordionStyle = {
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    marginBottom: '10px'
  };

  const titleStyle = {
    padding: '15px',
    backgroundColor: '#f5f5f5',
    cursor: 'not-allowed', // Cursor modificado para indicar que não é clicável
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: '8px',
    opacity: 0.7 // Opacidade reduzida para indicar que está desativado
  };

  const contentStyle = {
    padding: '15px',
    borderTop: '1px solid #e0e0e0'
  };

  const videoTitleStyle = {
    padding: '10px',
    cursor: 'pointer', // Cursor modificado para indicar que não é clicável
    color: '#4285F4',
    borderRadius: '4px',
    marginBottom: '5px',
    transition: 'background-color 0.2s',
    opacity: 0.7, // Opacidade reduzida para indicar que está desativado
    ':hover': {
      backgroundColor: '#f5f5f5'
    }
  };

  const videoContainerStyle = {
    position: 'relative',
    paddingBottom: '56.25%', // 16:9 aspect ratio
    height: 0,
    marginTop: '10px',
    marginBottom: '10px'
  };

  const iframeStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    borderRadius: '8px',
    border: 'none'
  };

  return (
    <div>
      {modules.map((module, moduleIndex) => (
        <div key={moduleIndex} style={accordionStyle}>
          <div 
            style={titleStyle}
            onClick={() => toggleModule(moduleIndex)}
          >
            <h3 style={{ margin: 0 }}>{module.title}</h3>
            <span>+</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default VideoAccordion;